import { useApolloClient, useQuery } from '@apollo/client';
import { EledoProfile, EledoProfileData, EledoProfileVars, GET_CURRENT_PROFILE } from 'graphql/EledoProfile';
import { useEffect, useState } from 'react'

const useCurrentProfile = () => {
  const client = useApolloClient();
  
  const [ currentProfile, setCurrentProfile] = useState<EledoProfile>();

  const { loading, error, data } = useQuery<EledoProfileData, EledoProfileVars>(GET_CURRENT_PROFILE);
  
  useEffect(() => {
    if (loading || !data){
      return
    }

    const currentProfile: EledoProfile = structuredClone(data.currentProfile)

    setCurrentProfile(currentProfile)
  }, [data, client, loading])

  return { loading, error, currentProfile }
}

export default useCurrentProfile